let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7w99d")).then(() => parcelRequire('6nVXP'));